import { Grid } from '@mui/material';

import { Switches, TextField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { LimitFormContentLayout } from '../limit-form-content-layout';
import { LimitComponentProps } from '../../types';

export const PerTransactionFulfillmentLimit = ({
  open,
  title,
  description,
  limitLabel,
}: LimitComponentProps) => {
  return (
    <LimitFormContentLayout
      title={title ?? 'Per Transaction Fulfillment Limit'}
      description={description ?? 'Per Transaction Fulfillment Limit'}
      action={<Switches name='awardCount.transaction.isEnabled' data={{}} />}
      open={open}
    >
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <TextField
            name='awardCount.transaction.limit'
            label={limitLabel || 'Times'}
            fieldProps={{
              parse: parseNumber,
            }}
          />
        </Grid>
      </Grid>
    </LimitFormContentLayout>
  );
};
